module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO57FinDelCurso.139f10a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO57FinDelCurso.mp4
// module id = 783
// module chunks = 1